import { useState } from 'react'
import { Skeleton } from '@mui/material'

import { useAccount, useRemoveAccountIcon, useUpdateAccountIcon } from 'src/hooks'
import { ImageInput } from 'src/components/form-title'
import { imageChangeHandler } from 'src/common/handlers'
import { ICustomIconFile, ISetStockImage } from 'src/types'
import { useStyles } from './styles'
import { ImageCropperModal } from 'src/components/image-cropper'

const AccountIconEditable = () => {
  const [imageToCrop, setImageToCrop] = useState<ICustomIconFile | null>(null)
  const [open, setOpen] = useState(false)

  const { data: account } = useAccount()
  const [file, setFile] = useState<File | null>(null)
  const { mutate: updateIcon, isLoading: isUpdating } = useUpdateAccountIcon()
  const { mutateAsync: removeIcon, isLoading: isRemoving } = useRemoveAccountIcon()
  const classes = useStyles()

  const handleModalClose = () => {
    setOpen(false)
    setImageToCrop(null)
  }

  const handleSetImage = (data: ICustomIconFile) => {
    setFile(data.file)
    if (!account) return
    updateIcon({ oldImage: account?.image, image: data })

    setOpen(false)
    setImageToCrop(null)
  }

  const handleImageChange = imageChangeHandler((data: ICustomIconFile) => {
    setOpen(true)
    setImageToCrop(data)
  })

  const handleIconRemove = () => {
    setFile(null)
    if (file) return

    return removeIcon()
  }

  const handleStockImageSet: ISetStockImage = (img) => {
    setOpen(true)
    setImageToCrop({ icon: img, file: null })
  }

  const isLoading = isUpdating || isRemoving
  return (
    <div className={classes.imageWrapper}>
      {!isLoading && account ? (
        <ImageInput
          originalImage={account.image}
          alt={account.account_holder}
          handleImageChange={handleImageChange}
          image={account.image_medium || account.image}
          isRound
          deleteImage={handleIconRemove}
          handleStockImageSet={handleStockImageSet}
        />
      ) : (
        <Skeleton width={80} height={80} variant="circular" />
      )}
      <ImageCropperModal
        handleClose={handleModalClose}
        open={open}
        setImage={handleSetImage}
        imageToCrop={imageToCrop}
        initialAspectRatio={`${1 / 1}-Circle`}
      />
    </div>
  )
}

export { AccountIconEditable }
